import { FC } from "react";
import { ICasinoGroupViewModel } from "@/fe-core/meta/interfaces/casino";
import CasinoGroupWidgetSwiper from "./CasinoGroupWidgetSwiper";
import classNames from "classnames";

const CasinoGroupWidgetSwiperWithTitle: FC<{
  group: ICasinoGroupViewModel;
  isLiveGame: boolean;
  hidePlayButton?: boolean;
  className?: string;
  groupId?: string;
}> = ({
  group,
  isLiveGame,
  hidePlayButton = true,
  className = "",
  groupId,
}) => {
    const category = groupId || group?.slug;

    const baseUrl = isLiveGame ? "/casino/live/" : "/casino/";

    const iconName = group?.name;

    return (
      <div className={classNames("container relative mt-8 md:mt-10", className)}>
        <CasinoGroupWidgetSwiper
          title={group?.name}
          group={group}
          key={`favorites`}
          href={`${baseUrl}${category}`}
          total={group?.games?.total}
          icon={iconName ? iconName : "jocuri-noi"}
          hidePlayButton={hidePlayButton}
        />
      </div>
    );
  };

export default CasinoGroupWidgetSwiperWithTitle;
